import React, { useState } from "react";
import { Select, InputNonOptimized, SubmitButton } from "components/Forms";
import getDigibasicConstraints from "services/digiBasic/getDigibasicConstraints";
import useAPI from "effects/useAPI";

const FeedRateOptimization = ({
  optimizedFeedRate,
  digibasicResponse,
  setSelectedOption,
}) => {
  const [
    errorDigibasicConstraints,
    loadingDigibasicConstraints,
    digibasicConstraintsResponse,
  ] = useAPI(() => getDigibasicConstraints());

  const [selectedConstraintId, setSelectedConstraintId] = useState("1");

  const constraintMapById = {
    "1": {
      name: "Feed Force",
      label: "(N)",
      value: digibasicResponse.OptimisationValidationRules.Min_FeedForce,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_FeedForcetxt,
    },
    "2": {
      name: "Cross Feed Force",
      label: "(N)",
      value: digibasicResponse.OptimisationValidationRules.Min_CrossFeedForce,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_CrossFeedForcetxt,
    },
    "3": {
      name: "Axial Force",
      label: "(N)",
      value: digibasicResponse.OptimisationValidationRules.Min_AxialForce,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_AxialForcetxt,
    },
    "4": {
      name: "Side Force",
      label: "(N)",
      value: digibasicResponse.OptimisationValidationRules.Min_SideForce,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_SideForcetxt,
    },
    "5": {
      name: "Torque",
      label: "(Nm)",
      value: digibasicResponse.OptimisationValidationRules.Min_Torque,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_Torquetxt,
    },
    "6": {
      name: "Power",
      label: "(W)",
      value: digibasicResponse.OptimisationValidationRules.Min_Power,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_Powertxt,
    },
    "7": {
      name: "MRR",
      label: "(cm³/min)",
      value: digibasicResponse.OptimisationValidationRules.Min_MRR,
      validationText:
        digibasicResponse.OptimisationValidationRules.Min_MRRtxt,
    },
  };

  const selectedConstraint =
    constraintMapById[selectedConstraintId] || constraintMapById["1"];

  const constraintLabel = selectedConstraint.label;
  const minimumOptimizationValue = selectedConstraint.value;
  const optimisationValidationRuleText = selectedConstraint.validationText;

  if (loadingDigibasicConstraints) {
    return <p>Loading</p>;
  }

  if (errorDigibasicConstraints) {
    return <p>Something went wrong.</p>;
  }

  const digibasicConstraints =
    digibasicConstraintsResponse?.digibasicConstraints || [];

  const constraintsOptions = digibasicConstraints.map((option) => ({
    key: option.optimisationConstraintId,
    value: option.optimisationConstraintId,
    label: option.optimisationConstraint,
  }));

  const constraintLabelSelection = (event) => {
    setSelectedConstraintId(event.target.value);
  };

  return (
    <div className="d-flex flex-column justify-content-center">
      <div className="d-flex flex-column">
        <div className="mb-4">
          <h2 className="d-flex justify-content-center">
            Feed Rate Optimization
          </h2>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm justify-content-center">
              <div
                className="d-flex flex-column justify-content-start"
                style={{ maxWidth: "35em" }}
              >
                <div className="d-flex col-sm-8 mb-3">
                  <label className="col-sm-10 col-form-label">
                    Optimization Constraint:
                  </label>
                  <div className="col-sm-12">
                    <Select
                      name="optimizationParameters.digibasicOptimisationConstraintId"
                      options={constraintsOptions}
                      className="form-control col-sm-12"
                      placeholder="Shape"
                      value={selectedConstraintId}
                      onChange={constraintLabelSelection}
                    />
                  </div>
                </div>

                <div className="d-flex col-sm-8 mb-5">
                  <label className="col-sm-10 col-form-label">
                    Constraint Magnitude:
                  </label>
                  <div className="col-sm-12">
                    <InputNonOptimized
                      name="optimizationParameters.selectedConstraintMagnitude"
                      type="float"
                      className="form-control"
                    />
                  </div>
                  <div
                    className="align-items-center d-flex"
                    style={{ fontSize: "16px" }}
                  >
                    {constraintLabel}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {minimumOptimizationValue !== "" && (
            <div className="alert alert-info" role="alert">
              <h5 className="d-flex justify-content-center">
                {optimisationValidationRuleText} : {minimumOptimizationValue}
              </h5>
            </div>
          )}

          {optimizedFeedRate?.data?.lambdaResponse?.Optimised?.Feedrate_New !=
            null && (
            <div className="alert alert-success mb-4" role="alert">
              <h5 className="d-flex justify-content-center">
                New Feed Rate is:{" "}
                {parseFloat(
                  optimizedFeedRate.data.lambdaResponse.Optimised.Feedrate_New
                ).toFixed(2)}{" "}
                (mm/min)
              </h5>
            </div>
          )}

          <div className="d-flex justify-content-around">
            <button
              className="btn btn-info waves-effect waves-light"
              style={{
                width: "7rem",
                backgroundColor: "#3498DB",
                color: "#fff",
                height: "2.6rem",
              }}
              onClick={() => setSelectedOption("history")}
              type="button"
            >
              Go to History
            </button>
            <SubmitButton
              className="btn btn-success btn-lg waves-effect waves-light mr-4 mb-3"
              style={{ width: "7rem" }}
            >
              Submit
            </SubmitButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedRateOptimization;